import { CardTitle as _CardTitle, CardTitleProps as _CardTitleProps } from "reactstrap";

    export const CardTitle = _CardTitle;
    export type CardTitleProps = _CardTitleProps;
    